import { FOOTER_MJML } from "../common/footer";
import { TRANSACTIONAL_HEADER } from "../common/header";

export const productLaunch = `
<mjml>
  <mj-head>
    <mj-title>Introducing Our New Product</mj-title>
    <mj-preview>We're excited to announce our latest innovation</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
    </mj-attributes>
  </mj-head>
  <mj-body>
    ${TRANSACTIONAL_HEADER(
      "Product Launch",
      "Introducing our newest innovation"
    )}
    
    <mj-section background-color="#ffffff" padding="30px 0">
      <mj-column>
        <mj-image src="https://via.placeholder.com/600x300?text=New+Product" alt="New Product" />
        <mj-text font-size="26px" color="#333333" font-family="Arial, sans-serif" align="center" font-weight="bold" padding-top="20px">Introducing {{product_name}}</mj-text>
        <mj-text font-size="18px" color="#555555" font-family="Arial, sans-serif" align="center">Available Starting {{launch_date}}</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 0 30px">
      <mj-column>
        <mj-text font-size="22px" color="#333333" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">We're thrilled to announce the launch of our newest product: <strong>{{product_name}}</strong>. After months of development and refinement, we're confident this will exceed your expectations and deliver exceptional value.</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f8f9fa" padding="30px 0">
      <mj-column width="100%">
        <mj-text font-size="24px" color="#333333" font-weight="bold" align="center">Key Features</mj-text>
        <mj-divider border-color="#343a40" border-width="1px" width="80px" />
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f8f9fa" padding="0 0 30px">
      <mj-column width="33%">
        <mj-image src="https://via.placeholder.com/120?text=Feature+1" alt="Feature 1" width="120px" />
        <mj-text font-size="18px" font-weight="bold" align="center">Premium Quality</mj-text>
        <mj-text font-size="14px" align="center">Built with premium materials and meticulous attention to detail.</mj-text>
      </mj-column>
      <mj-column width="33%">
        <mj-image src="https://via.placeholder.com/120?text=Feature+2" alt="Feature 2" width="120px" />
        <mj-text font-size="18px" font-weight="bold" align="center">Innovative Design</mj-text>
        <mj-text font-size="14px" align="center">Cutting-edge features that set a new standard in the industry.</mj-text>
      </mj-column>
      <mj-column width="33%">
        <mj-image src="https://via.placeholder.com/120?text=Feature+3" alt="Feature 3" width="120px" />
        <mj-text font-size="18px" font-weight="bold" align="center">Versatile Functionality</mj-text>
        <mj-text font-size="14px" align="center">Adaptable to various uses with intuitive controls.</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="30px 0">
      <mj-column width="50%">
        <mj-image src="https://via.placeholder.com/300x200?text=Product+Details" alt="Product Details" />
      </mj-column>
      <mj-column width="50%">
        <mj-text font-size="22px" color="#333333" font-weight="bold">Early Access Offer</mj-text>
        <mj-text font-size="16px" color="#555555">As a valued customer, we're offering you special early access. Order now and receive:</mj-text>
        <mj-text font-size="16px" color="#555555" padding-top="10px">
          • 15% introductory discount<br/>
          • Priority shipping<br/>
          • Exclusive bonus accessories<br/>
          • Extended warranty
        </mj-text>
        <mj-button background-color="#4CAF50" color="#ffffff" href="#" border-radius="4px" font-weight="bold">Shop Now</mj-button>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f8f9fa" padding="20px">
      <mj-column>
        <mj-text font-size="20px" font-weight="bold" align="center">Limited Time Offer</mj-text>
        <mj-text font-size="16px" align="center">Early access promotion ends {{promo_end_date}}</mj-text>
        <mj-button background-color="#4CAF50" color="#ffffff" font-family="Arial, sans-serif" href="#" width="200px" border-radius="4px">Learn More</mj-button>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "productLaunch",
  name: "Product Launch",
  category: "product",
  description:
    "An engaging product launch announcement that highlights new features and benefits with special early access offers for customers.",
  features: [
    "Product showcase",
    "Key feature highlights",
    "Early access promotions",
    "Special offer details",
    "Clear call-to-action",
  ],
  subject: "Introducing Our New Product",
  subTitle: "We're excited to announce our latest innovation",
  mjmlTemplate: productLaunch,
};
